import React from "react";
import Modal from "react-modal";

export default function ConfirmModal({modalIsOpen, closeModal, newItem, context, props}) {

    const handleClose = function () {
        closeModal()
    }

    const handleViewCart = function () {
        props.history.push("/checkout/")
    }

    return (
        <Modal
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            contentLabel="Item added to cart"
            className="modal"
            overlayClassName="overlay"
            appElement={document.getElementById("main")}
        >
            <div className="modal-container">
                <div className="modal-header">
                    <h2>Item Added To Cart!</h2>
                    <button className="button" onClick={handleClose}>
                        X
                    </button>
                </div>
            <div className="modal-contents-individual">
                <div className="modal-item">
                    <div className="left">
                        <div>Your Training Session</div>
                        <div>Session Type</div>
                    </div>
                    <div className="right">
                        <div className="name">{newItem.name}</div>
                        <div className="description">{newItem.description}</div>
                    </div>
                </div>
            </div>
            <div className="buttons-individual">
                <button className="button" onClick={handleClose}>Close</button>
                <button className="button" onClick={handleViewCart}>View Cart</button>
            </div>
        </div>
        </Modal>
        );
}